"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Partner = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.titleList,
    titleList = _a === void 0 ? [] : _a,
    _b = props.contentList,
    contentList = _b === void 0 ? [] : _b,
    flexTitle = props.flexTitle,
    style = props.style,
    description = props.description,
    restProps = __rest(props, ["titleList", "contentList", "flexTitle", "style", "description"]);
  var titleLength = titleList.length || 5;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), description ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-flex-partner-tiers-container-children__article',
    dangerouslySetInnerHTML: {
      __html: description
    }
  })) : '', /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: 'partner',
    ref: ref
  }, restProps), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("tbody", null, titleList ? (/*#__PURE__*/_react["default"].createElement("tr", {
    className: "par-top"
  }, titleList.map(function (title_item, key) {
    var text = title_item.text,
      width = title_item.width;
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: key,
      style: width ? {
        width: width,
        minWidth: width
      } : {}
    }, text);
  }))) : '', contentList.map(function (content_item, content_key) {
    var titleOf = content_item.titleOf,
      title = content_item.title,
      textList = content_item.textList;
    var width = (titleList[content_key] || {}).width;
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: (0, _classnames["default"])({
        'par-titile': titleOf
      }),
      key: content_key
    }, titleOf ? (/*#__PURE__*/_react["default"].createElement("td", {
      style: width ? {
        width: '100%',
        minWidth: '100%'
      } : {},
      key: content_key,
      colSpan: titleLength,
      dangerouslySetInnerHTML: {
        __html: title || ''
      }
    })) : textList.map(function (text_item, text_key) {
      var text = text_item.text;
      var icon = text_item.icon;
      var _a = (0, _utils.fomateFileData)(icon),
        url = _a.url,
        _b = _a.alt,
        alt = _b === void 0 ? '' : _b;
      if (url) {
        text = "<img src=" + url + " alt=" + alt + " />";
      }
      var width = (titleList[text_key] || {}).width;
      return /*#__PURE__*/_react["default"].createElement("td", {
        style: width ? {
          width: width,
          minWidth: width
        } : {},
        key: text_key,
        colSpan: 1,
        dangerouslySetInnerHTML: {
          __html: text
        }
      });
    }));
  }))))));
});
Partner.displayName = 'TCIPartner';
var _default = exports["default"] = Partner;